



























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import myResult from '@/components/resultPage/main.vue';
import { Action, namespace } from 'vuex-class';
// @ts-ignore
import { clearUserData } from '@/store/modules/user';

const User = namespace('user');
@Component({
  components: {
    myResult,
  },
})
export default class ResultPage extends Vue {
  protected themeCode: number = 0;
  @User.Action('clearUserData') protected clearUserData!: clearUserData<string>;
  protected data: TypeBase.ResultDataItem = {
    state: '403',
  };
  // 退出登录
  protected async handleLogout(): Promise<void> {
    const { code } = await this.$api.user.logout();
    if (!code) {
      this.$message.success(this.t('common', '退出成功'));
      this.clearUserData();
      this.$router.push('/login');
    }
  }
  protected handleReturnOldSys(): void {
    window.location.href = this.$config.oldSysLoginPath;
  }
  private created(): void {
    this.themeCode = Number(this.$route.query.code) || this.$enum.common.NotPermission.DEFAULT;
  }
}
